import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, filter, map, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading = new BehaviorSubject<boolean>(false);
  private allLoading = new Array<LoadingModel>();
  private allLoading$ = new Subject<LoadingModel[]>();

  constructor() {}

  startLoad(url: string): void {
    this.loading.next(true);

    if (!this.allLoading.find((x) => x.url === url)) {
      this.allLoading.push(new LoadingModel(true, url));
      this.allLoading$.next(this.allLoading);
    }
  }

  finishLoad(url: string): void {
    this.loading.next(false);

    this.allLoading.forEach((x) => (x.isLoading = x.url !== url));
    this.allLoading$.next(this.allLoading);

    this.allLoading = this.allLoading.filter((x) => x.url !== url);
    this.allLoading$.next(this.allLoading);
  }

  isLoading(): Observable<boolean> {
    return this.loading;
  }

  isLoadingUrl(url: string): Observable<boolean> {
    return this.allLoading$.pipe(
      filter((x) => x.some((y) => y.url.includes(url))),
      map((x) => x.find((y) => y.url.includes(url))?.isLoading ?? false),
      distinctUntilChanged()
    );
  }
}

class LoadingModel {
  constructor(public isLoading: boolean, public url: string) {}
}
